/* global debounce */
if (!customElements.get('cart-note')) {
  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.disclosure = this.closest('details');

      if (this.disclosure && this.disclosure.matches('.cart-note-disclosure')) {
        this.cartNoteToggle = this.disclosure.querySelector('.js-show-note');
      }

      this.textarea = this.querySelector('#cart-note, textarea[name="note"]');
      this.saveBtn = this.querySelector('.js-cart-note-save');
      this.savedEl = this.querySelector('.js-cart-note-saved');

      this.fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      };

      this.init();
    }

    init() {
      this.debouncedHandleNoteChange = debounce(this.handleNoteChange.bind(this), 300);
      this.addEventListener('input', this.debouncedHandleNoteChange);

      if (this.saveBtn && this.textarea) {
        this.saveBtn.addEventListener('click', this.handleSaveClick.bind(this));
      }
    }

    handleNoteChange(evt) {
      if (this.cartNoteToggle) {
        const label = evt.target.value ? theme.strings.editCartNote : theme.strings.addCartNote;
        if (this.cartNoteToggle.textContent !== label) this.cartNoteToggle.textContent = label;
      }

      this.fetchRequestOpts.body = JSON.stringify({ note: evt.target.value });
      fetch(theme.routes.cartUpdate, this.fetchRequestOpts);
    }

    handleSaveClick() {
      if (!this.textarea || !theme || !theme.routes || !theme.routes.cartUpdate) return;
      const value = this.textarea.value || '';

      if (this.cartNoteToggle) {
        const label = value ? theme.strings.editCartNote : theme.strings.addCartNote;
        if (this.cartNoteToggle.textContent !== label) this.cartNoteToggle.textContent = label;
      }

      this.fetchRequestOpts.body = JSON.stringify({ note: value });
      fetch(theme.routes.cartUpdate, this.fetchRequestOpts).then(() => this.showSaved());
    }

    showSaved() {
      if (!this.savedEl) return;
      this.savedEl.hidden = false;
      clearTimeout(this._savedTimeout);
      this._savedTimeout = setTimeout(() => {
        this.savedEl.hidden = true;
      }, 2500);
    }
  }

  customElements.define('cart-note', CartNote);
}
